import { Col, Row } from "antd";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { I18Text } from "src/types/i18Text";
import { down } from "styled-breakpoints";
import styled from "styled-components";
import { Title } from "sunday-component";
import CommonButton from "../Common/Button";
import {
  CoverageItemTable,
  CoverageItemTableProps,
} from "../Common/CoverageItemTable";

const Button = styled(CommonButton)`
  max-height: 48px;
`;
const ButtonContainer = styled(Col)`
  ${down("sm")} {
    width: -webkit-fill-available;
  }
  max-height: 48px;
  width: 330px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export type CoverageTableSectionProps = CoverageItemTableProps & {
  policyDetailUrl?: I18Text;
};

export const CoverageTableSection = ({
  allCoverageItems,
  insurerPlanCode,
  policyDetailUrl,
  tablePrimaryColor,
  tableSecondaryColor,
}: CoverageTableSectionProps): JSX.Element => {
  const { t } = useTranslation("plan");
  const { locale } = useRouter();

  return (
    <Container>
      <Row justify="center">
        <Title level={1}>{t("planCoverageDetail.title")}</Title>
      </Row>
      <CoverageItemTable
        allCoverageItems={allCoverageItems}
        insurerPlanCode={insurerPlanCode}
        tablePrimaryColor={tablePrimaryColor}
        tableSecondaryColor={tableSecondaryColor}
      />
      {policyDetailUrl && (
        <ButtonContainer>
          <Link href={policyDetailUrl[locale]} passHref>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a target="_blank">
              <Button
                fullWidth
                data-testid="download-policy-button"
                data-gtm-input-code="download-policy-button"
                data-cy={`plan-coverage-detail.${insurerPlanCode}.detail-button`}
                type="outlined"
                block
              >
                {t("planCoverageDetail.download")}
              </Button>
            </a>
          </Link>
        </ButtonContainer>
      )}
    </Container>
  );
};
